import { Component, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TimelineModule } from 'primeng/timeline';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-status-updates',
  standalone: true,
  imports: [TimelineModule, TranslateModule, NgClass, CommonModule, ButtonModule],
  providers: [MessageService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './status-updates.component.html',
  styleUrl: './status-updates.component.scss'
})
export class StatusUpdatesComponent {
  @Input() events: any[];
  @Input() orderStatus: string;
  @Input() attributeValues: any;
  @Input() metaDataService: any;
  @Input() configService: any;
  @Input() orderStatusConst: any;
  @Input() eventStatusConst: any;
  @Input() isStatusUpdate: boolean;
  @Input() showPartialOrderButton: boolean;
  @Output() openFullOrderDialog = new EventEmitter<void>();
  @Output() showPartialOrderDialogBoxChange = new EventEmitter<boolean>();
  @Output() showRejectOrderDialogBoxChange = new EventEmitter<boolean>();

  isSiteUser(): boolean {
    return this.configService?.isSiteUser?.() ?? false;
  }

  getDisplayStatus(event: any): string {
    if (!this.isSiteUser()) {
      return event.status;
    }

    const siteStatusMap: Record<string, string> = {
      'New Order': 'Order Submitted',
      'Order Received': 'Order Delivered',
    };

    return siteStatusMap[event.status] ?? event.status;
  }

  isOrderConfirmedStatus(event: any): boolean {
    return event.status?.toLowerCase()?.includes('confirmed');
  }

  getMarkerImage(event: any): string {
    if (event.statusType === 'done' || event.statusType === 'in-progress') {
      return '../../../../../../assets/images/mi-theme/light/nav/status_done.svg';
    }

    if (event.statusType === 'upcoming') {
      const upcomingEvents = this.events.filter(e => e.statusType === 'upcoming');
      const isFirstUpcoming = upcomingEvents[0]?.index === event.index;

      if (isFirstUpcoming) {
        return '../../../../../../assets/images/mi-theme/light/nav/status_inprogress.svg';
      } else {
        return '../../../../../../assets/images/mi-theme/light/nav/status_upcoming.svg';
      }
    }

    return '../../../../../../assets/images/mi-theme/light/nav/status_upcoming.svg';
  }
}
